import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';

import { useResetPageNumberAfterFiltering } from '../../../../../../shared/hooks/use-reset-page-number-after-filtering/use-reset-page-number-after-filtering.hook';
import { onChangeTableRowsPerPage } from '../../../../../../shared/utils/on-change-table-rows-per-page/on-change-table-rows-per-page.util';
import { onTablePageChange } from '../../../../../../shared/utils/on-table-page-change/on-table-page-change.util';
import { useAppDispatch } from '../../../../../../store/hooks';
import NoResults from '../../../../../shared/components/no-results/NoResults';
import SDCTable from '../../../../../shared/components/ui/Table/components/table/SDCTable';
import { getPaginationConfig } from '../../../../../shared/components/ui/Table/utils/get-pagination-config.util';
import { bulkActionHandler } from '../../../../../shared/utils/bulk-action-handler/bulk-action-handler.util';
import {
  addPagination,
  resetPagination,
} from '../../store/slices/slices/reviews.slice';
import { getReviewsTotalCount } from '../../thunks/get-reviews-total-count.thunk';
import { useGetReviewsTableSelectors } from './hooks/use-get-reviews-table-selectors/use-get-reviews-table-selectors.hook';
import { useShowDeleteReviewsModal } from './hooks/use-show-delete-reviews-modal/use-show-delete-reviews-modal.hook';
import { reviewsTableColumnDefUtil } from './utils/reviews-table-column-def.util';

export const ReviewsTable = (): JSX.Element => {
  const {
    reviews: tableRows,
    reviewsFilters,
    activeMandantId,
    appId,
    isLoading,
  } = useGetReviewsTableSelectors();
  const {
    header: headerFilters,
    pagination: { pageNumber, totalCount, size },
  } = reviewsFilters;

  const dispatch = useAppDispatch();

  const [ids, setIds] = useState<number[]>([]);

  useEffect(() => {
    if (activeMandantId !== null && appId) {
      dispatch(
        getReviewsTotalCount({ appId: +appId, filters: reviewsFilters })
      );
    }
  }, [headerFilters, activeMandantId]);

  const modalComponent = useShowDeleteReviewsModal(ids, reviewsFilters, appId);

  useResetPageNumberAfterFiltering(
    totalCount,
    pageNumber,
    size,
    resetPagination
  );

  return (
    <>
      <Box data-testid="reviews-table">
        {tableRows.length > 0 && (
          <SDCTable
            sx={{
              td: {
                wordWrap: 'break-word',
                overflow: 'hidden',
                padding: '25px 4px',
              },
            }}
            ariaLabel="reviews-table"
            bulkActions={true}
            bulkActionHandler={bulkActionHandler(setIds)}
            checkboxSelection={true}
            columns={reviewsTableColumnDefUtil}
            rows={tableRows}
            stickyHeader={true}
            paginationConfig={getPaginationConfig(
              totalCount,
              size,
              pageNumber,
              onTablePageChange(dispatch, size, addPagination),
              onChangeTableRowsPerPage(dispatch, addPagination)
            )}
          />
        )}
        {tableRows?.length === 0 && !isLoading && <NoResults />}
      </Box>
      {modalComponent}
    </>
  );
};
